export default __webpack_public_path__ + "static/media/Earn.d8bb9b77.png";